import { Scale, Building2, Workflow, Network } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const AUDIENCES = [
  {
    icon: Scale,
    title: "US Patent Law Firms",
    text: "Support patent prosecution, docketing, portfolio management, and data quality activities.",
  },
  {
    icon: Building2,
    title: "Corporate IP Departments",
    text: "Improve the reliability of internal patent portfolio records and IP databases.",
  },
  {
    icon: Workflow,
    title: "IP Operations Teams",
    text: "Support large-scale data validation and quality-control projects.",
  },
  {
    icon: Network,
    title: "Patent Management Service Providers",
    text: "Provide scalable IP data validation support for portfolio and database projects.",
  },
];

export default function WhoWeServe() {
  return (
    <section id="industries" data-testid="industries-section" className="bg-navy grain relative py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
        <Reveal>
          <SectionLabel index="04" dark>Who We Serve</SectionLabel>
          <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
            <h2 className="lg:col-span-7 font-display font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
              Built for the teams who carry patent data risk
            </h2>
            <p className="lg:col-span-5 text-slate-400 text-base leading-relaxed">
              Focused support for US patent law firms, corporate legal departments, IP teams,
              and patent professionals.
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {AUDIENCES.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.08} className="bg-navy">
              <div data-testid={`audience-card-${i + 1}`} className="p-8 lg:p-10 h-full group hover:bg-navy-light transition-colors duration-500">
                <a.icon className="w-8 h-8 text-blue-400 mb-8 transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.5} />
                <h3 className="font-display font-bold text-white text-lg mb-4 tracking-tight leading-snug">{a.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{a.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
